import { Dialog, DialogActions, DialogTitle, makeStyles } from "@material-ui/core";
import { Typography } from "@mui/material";
import React from "react";
import {
  DeleteButton,
  StyledTabButton,
} from "../shared/helpers/GlobalStylesv5";
import { tokens } from "../../theme/tokens";

const useStyle = makeStyles(() => ({
  dilaogTitle: {
    textAlign: "center",
    color: tokens.color.text.primary,
    fontSize: "1rem !important",
    textTransform: "inherit",
  },
  dialogPaper: {
    width: "550px",
    paddingTop: tokens.space[4],
    paddingBottom: tokens.space[4],
  },
  dialogAction: {
    justifyContent: "center",
    columnGap: tokens.space[3],
    paddingTop: tokens.space[4],
  },
}));

function Index({ text, state, setHandleClose, onConfirm }) {
  const classes = useStyle();
  const handleClose = () => {
    return setHandleClose();
  };
  const setConfirm = () => {
    return onConfirm();
  };
  return (
    <Dialog
      open={state}
      handleClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="alert-dialog-title" className={classes.dilaogTitle}>
        <Typography variant="h5">{text}</Typography>
      </DialogTitle>

      <DialogActions className={classes.dialogAction}>
        <DeleteButton onClick={setConfirm} autoFocus>
          Yes
        </DeleteButton>
        <StyledTabButton onClick={handleClose}>No</StyledTabButton>
      </DialogActions>
    </Dialog>
  );
}

export default Index;
